import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login/Login.vue'
import Logout from '@/views/Login/Logout.vue'
import Register from '@/views/Login/Register.vue'
import Recovery from '@/views/Login/Recovery.vue'
import Admin from '@/views/Admin/Admin.vue'
import Users from '@/views/Admin/Users.vue'
import Zones from '@/views/Admin/Zones.vue'
import Orders from '@/views/Admin/Orders.vue'
import Reminders from '@/views/Admin/Reminders.vue'
import Roles from '@/views/Admin/Roles.vue'
import Config from '@/views/Admin/Config.vue'
import Profile from '@/views/Admin/Profile.vue'
import firebase from 'firebase/app'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: '/pedidos'
  },
  // {
  //   path: '/registrarse',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/recuperar-clave',
    name: 'Recovery',
    component: Recovery
  },
  {
    path: '/entrar',
    name: 'Login',
    component: Login
  },
  {
    path: '/salir',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/',
    name: 'Admin',
    component: Admin,
    meta: { authRequired: true },
    children: [
      {
        path: 'pedidos',
        name: 'Orders',
        component: Orders,
        props: { show: 'pending' },
        meta: { superUser: 'all', admin: 'all', commercial: 'view', driver: 'view' }
        // driver can just edit Status and count, but limited in Order view
        // commercial can just edit Documentation limited in Order view
      },
      {
        path: 'pedidos/realizados',
        name: 'OrdersCompleted',
        component: Orders,
        props: { show: 'completed' },
        meta: { superUser: 'all', admin: 'all', commercial: 'view', driver: 'view' }
        // driver can just edit Status and count, but limited in Order view
        // commercial can just edit Documentation limited in Order view
      },
      {
        path: 'pedidos/todos',
        name: 'OrdersAll',
        component: Orders,
        props: { show: 'all' },
        meta: { superUser: 'all', admin: 'all', commercial: 'view', driver: 'view' }
        // driver can just edit Status and count, but limited in Order view
        // commercial can just edit Documentation limited in Order view
      },
      {
        path: 'generadores',
        name: 'Users',
        component: Users,
        meta: { superUser: 'all', admin: 'all', commercial: 'view' }
      },
      {
        path: 'zonas',
        name: 'Zones',
        component: Zones,
        meta: { superUser: 'all', admin: 'all' }
      },
      {
        path: 'recordatorios',
        name: 'Reminders',
        component: Reminders,
        meta: { superUser: 'all', admin: 'all' }
      },
      {
        path: 'administradores',
        name: 'Roles',
        component: Roles,
        meta: { superUser: 'all' }
      },
      {
        path: 'configuracion',
        name: 'Config',
        component: Config,
        meta: { superUser: 'all', admin: 'all' }
      },
      {
        path: 'perfil',
        name: 'Profile',
        component: Profile,
        meta: { superUser: 'all', admin: 'all', commercial: 'all', driver: 'all' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    // if auth required
    firebase.auth().onAuthStateChanged(userAuth => {
      if (userAuth) {
        // Logged user
        firebase.auth().currentUser.getIdTokenResult()
          .then(function ({ claims }) {
              if ( claims.superUser || claims.admin || claims.commercial || claims.driver ) {
                // Permission to access admin area
                let userPermissions = ''
                if( claims.superUser ) userPermissions = 'superUser'
                else if( claims.admin ) userPermissions = 'admin'
                else if( claims.commercial ) userPermissions = 'commercial'
                else if( claims.driver ) userPermissions = 'driver'
  
                const list = routes.find(e => e.name == 'Admin').children
                const section = list.find( e => e.name == to.name )
  
                if( section && section.meta[userPermissions] ) {
                  // Has permission for this section?
                  return next()
                } else {
                  // Hasn't got permission for this section
                  return next('/')
                }
              } else { 
                // Insuficient permission to access admin area
                return next('/salir')
              }
            }
          )
      } else {
        // No logged user
        next('/entrar')
      }
    })
  } else {
    // No auth required
    next()
  }
})

export default router
